import { PossibleValuesHierarchy } from "./possible-values-hierarchy";

export class Ethnicity {
  constructor(
    public studyId: number | null,
    public studyTemplateId: number | null,
    public studyEthnicityClassificationId: number | null,
    public ethnicityClassificationId: number | null,
    public required: boolean | null,
    public tupleVersion: number | null,
    public possibleValues?: PossibleValuesHierarchy[] | null
) { }
}
